import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { AppConstant } from './modules/core/constant/core.constant';
import { PageNotFoundComponent } from './modules/core/components/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'reset',
    loadChildren: () => import('./modules/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'pagenotfound',
    component: PageNotFoundComponent
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'pagenotfound'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  private isNavigationLoading = new BehaviorSubject<boolean>(true);

  constructor(private router: Router, private titleService: Title) {

    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.setNavigationStatus(true);
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.setPageTitle();
          this.setNavigationStatus(false);
          break;
        }
        default:
          { break; }
      }
    });
  }

  private setNavigationStatus(status: boolean) {
    this.isNavigationLoading.next(status);
  }

  getNavigationStatus(): Observable<boolean> {
    return this.isNavigationLoading.asObservable();
  }

  private setPageTitle() {
    this.titleService.setTitle(AppConstant.GLOBAL_HEADER_NAME);
  }
}
